module.exports = {
  Splash: {
    email: 'Email',
    password: 'Password',
    forgot: 'Forgot password?',
    login: 'Sign In',
    splashTitle: 'Find your perfect candidate in minutes',
    splashSubtitle:
      'Meet your personal assistant to source the best candidates for your open jobs',
    step1: 'Step 1',
    step2: 'Step 2',
    step3: 'Step 3',
    heading1: 'Input your ideal candidate profile',
    heading2: "We'll send you a personalized batch of candidates to review",
    heading3: 'Approve or reject each candidate. We learn your preferences!',
    forgotTitle: 'Forgot your password?',
    close: 'Close',
    submit: 'Submit',
    errorLogin: 'Invalid username or password',
    sign_up_text: 'Sign up for a Free Trial',
    forgot_text1: 'Please verify your credentials and try again or ',
    forgot_text2: 'click here',
    forgot_text3: 'if you forgot your password.',
    error_email: 'Please enter your email address',
    password_recovery_instructions:
      'Please check your email and follow the instructions we just sent you.',
    error_account: 'We cannot find your account.',
  },
  Register: {
    title: 'Sign Up',
    first_name: 'First name',
    last_name: 'Last name',
    company: 'Company',
    job_title: 'Job title',
    email: 'Email address',
    password: 'Password',
    password_hint: 'At least 8 characters length.',
    password2: 'Re-type password',
    submit: 'Submit',
    error_required: 'This field is required',
    error_password: 'Password is too short',
    error_passwords: 'Passwords do not match',
    error_duplicate: 'This e-mail is already registered.',
  },
  Project: {
    welcome: 'Welcome',
    title: 'create your first project!',
    project_name: 'Project Name',
    hiring_company: 'Hiring Company',
    job_role: 'Job Role',
    seniority: 'Seniority',
    location: 'Locations',
    hiring_manager: 'Hiring Manager LinkedIn Profile',
    hiring_manager_tip:
      'Insert link to the LinkedIn profile of the hiring manager',
    special_skills: 'Skills',
    skills_tip: 'Enter one skill per line.',
    add_more_skills: 'Add more skills',
    job_description: 'Job Description',
    description_tip: 'Upload link to Job Description.',
    ideal_candidate: 'Ideal Candidate LinkedIn Profiles',
    candidate_tip:
      'Insert links to the LinkedIn profiles of your ideal candidates',
    add_more_links: 'Add more ideal candidates',
    title_settings: 'Project settings',
    save: 'Save',
    title_add: 'Add new project',
    finish: 'Finish',
    next_button: 'Next',
    error_required: 'This field is required',
    error_linkedin_url: 'All candidate URLs must be valid LinkedIn profiles',
    create_new_project: 'Create new project',
    create_new_project_subtitle: `Tell us about who you're looking for. No need for complex Boolean searches.
      We'll make sure to find all the relevant candidates.`,
    analyzing_message: 'Analyzing your ideal candidates...',
    years_of_exp: 'Years of Experience',
    years_exp_min: 'Min',
    years_exp_max: 'Max',
  },
  Profile: {
    success: 'Profile updated successfully!',
    title: 'Profile',
    subtitle: 'Add or change user profile on your account.',
    tip: 'Choose a unique password to protect your account',
    first_name: 'First name',
    last_name: 'Last name',
    company: 'Company name',
    job_title: 'Job title',
    email: 'Email address',
    change_password: 'Change password',
    password_hint: 'Choose a unique password to protect your account',
    password: 'Password',
    password2: 'Re-type password',
    save: 'Save',
    error_required: 'This field is required',
    error_password_short: 'Password is too short',
    error_password_match: 'Passwords do not match',
    error_generic: 'An error occurred when trying to update your profile.',
  },
  Panel: {
    add_new_project: 'Add new project',
    add_new_project_tooltip: 'Click here to add a Project',
    create_new: 'create new',
    hello: 'Hello',
    profile: 'Profile',
    sign_out: 'Sign out',
    review: 'Review',
    approved: 'Approved',
    contacted: 'Contacted',
    interviews: 'Interviews',
    null_title_first_time: 'Welcome to Hirefly!',
    null_subtitle_first_time: 'Let’s create your first project.',
    null_title_under_review:
      'We are working on finding you the best candidates!',
    null_subtitle_under_review: 'Please check back in 1-2 minutes!',
    null_title_approved: 'There are no approved candidates.',
    null_subtitle_approved: 'Review your candidates first!',
    null_title_contacted: 'You have not contacted any candidates yet.',
    null_subtitle_contacted: 'Review your candidates!',
    null_title_interviewing: 'You have not scheduled any interviews yet.',
    null_title_not_interested: 'There are no uninterested candidates.',
    null_title_rejected: 'There are no rejected candidates.',
    null_title_empty: 'There are no candidates available.',
    null_subtitle_empty: 'Review your candidates!',
    null_title_done:
      "Great job! You're done reviewing today's batch of candidates!",
    null_subtitle_done: 'Check back tomorrow!',
    null_subtitle_rejected: '',
    null_title_interested: "We're looking for more interested candidates!",
    null_subtitle_interested: '',
    project_settings: 'Project Settings',
    rejected_candidates: 'Rejected Candidates',
    not_interested_candidates: 'Not Interested Candidates',
  },
  Card: {
    at: 'at',
    location: 'Location',
    years_of_experience: 'Total years of experience',
    reviewed_by: 'Reviewed by',
    relevant_yoe: 'Estimated relevant experience',
    years: 'years',
    work_experience: 'Work Experience',
    education: 'Education',
    summary: 'Summary',
    see_less: 'Less...',
    see_more: 'More...',
    why_should: 'Why you should hire',
    skills: 'Skills',
    contacted: 'Contacted',
    tell_us_reason: 'Tell us a reason',
    please_help_us:
      'Please help us improve your results by indicating reasons for rejection',
    close: 'Close',
    error_reasons: 'Please indicate reasons for rejection',
    select: 'Select Reason',
    reasons: {
      JOB_TITLE_NOT_MATCHED: "Don't like current job title",
      DONT_LIKE_COMPANY: "Don't like current company",
      // NOT_IN_DESIRED_LOCATION: "Don't like location",
      NOT_ENOUGH_EXPERIENCE: 'Not enough years of experience',
      CANDIDATE_OVERQUALIFIED: 'Overqualified',
      EXPERIENCE_NOT_RELEVANT: 'Work history not relevant',
      SKILLS_NOT_MATCHED: 'Skills listed not relevant ',
      // DIVERSITY_PROFILE_NOT_MATCHED: 'Diversity profile not matched',
      RESPONSE_PROB_LOW: 'Unlikely to respond',
      // NOT_PRESTIGIOUS_SCHOOL: 'Not prestigious school',
      EDUCATION_NOT_HIGH: 'Want higher degrees',
      VISA: 'Likely needs Visa sponsorship',
      OTHER: 'Other',
      ALREADY_CONTACTED: 'Candidate already contacted',
    },
  },
};
